var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwilight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.139 10.313A4.812 4.812 0 0114.95 15.2a.689.689 0 00.858.677 2.066 2.066 0 012.58 1.997 2.062 2.062 0 01-2.063 2.062H4.64a2.749 2.749 0 11.138-5.496.688.688 0 00.7-.516 4.815 4.815 0 014.662-3.611zm6.149 4.124A6.187 6.187 0 004.3 13.076a4.124 4.124 0 00.34 8.235h11.685a3.437 3.437 0 000-6.874h-.037z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.257 1.009a.687.687 0 10-1.375 0v1.375a.687.687 0 101.375 0V1.009zm5.145 2.7a.688.688 0 10-.972-.972l-.973.972a.688.688 0 10.973.973l.972-.973zM9.708 2.737a.687.687 0 00-.972.972l.972.973a.688.688 0 00.973-.973l-.973-.972zm2.384 4.639a2.75 2.75 0 114.531 3.021c.274.387.511.8.71 1.235a4.124 4.124 0 10-6.655-4.434c.484.015.957.076 1.414.178zm6.164 5.6a4.824 4.824 0 012.093 1.474.687.687 0 00.053-1.02l-.972-.972a.688.688 0 00-1.174.518zm2.5-5.093a.687.687 0 100 1.375h1.375a.687.687 0 100-1.375h-1.375z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.25
  })));
}
export default __webpack_public_path__ + "media/small/twilight-34e96e41.svg";
export { SvgTwilight as ReactComponent };